export default {
  title: 'Webhook-ondertekeningsgeheim',
  warning:
    'Bewaar dit geheim nu — het wordt niet nogmaals getoond. Gebruik het om de header X-Webhook-Signature te verifiëren.',
  done: 'Klaar',
};
